import { Suspense, useEffect } from "react";
import AppRoutes from "./view/components/routes/AppRoutes";
import Loader from "./view/components/shared/Loader";
import { getEnvVariable } from "./constants/brandConfig";
import { BRAND_NAME, META_TITLE, META_DESCRIPTION, domain } from "./constants/Branding";
import { initBrandTracking } from "./constants/Tracking";
import { store } from "./App.utils";
import { Provider } from "react-redux";
import { Slide, ToastContainer } from "react-toastify";
import { X } from "lucide-react";
import { SignUpModalProvider } from "./view/context/SignUpModalContext";
import { ResendEmailModalProvider } from "./view/context/ResendEmailModalContext";
import { ForgotPasswordModalProvider } from "./view/context/ForgotPasswordModalContext";
import AppErrorBoundary from "./view/components/shared/AppErrorBoundary";
import { CompetitionViewEnum, setSelectedView } from "@hypexone/uicore";

function App() {
  const updateFavicon = () => {
    let link: any = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.setAttribute("href", getEnvVariable(domain, "favicon"));
  };

  const updateTitle = () => {
    document.title = META_TITLE || BRAND_NAME;
  };

  const updateMetaDescription = () => {
    if (!META_DESCRIPTION) return;

    let meta: any = document.querySelector("meta[name='description']");

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", META_DESCRIPTION);
  };

  useEffect(() => {
    // Load favicon
    updateFavicon();
    // Update title
    updateTitle();
    // Set this brand's meta description, if configured
    updateMetaDescription();
    // Init this brand's Facebook Pixel / GTM, if configured
    initBrandTracking();
    // Sport lists open grouped by competition; "View by" can still switch.
    store.dispatch(setSelectedView(CompetitionViewEnum.COMPETITION));
  }, []);
  
  return (
    <div className="h-full">
      <Provider store={store}>
        <SignUpModalProvider>
          <ResendEmailModalProvider>
            <ForgotPasswordModalProvider>
              <Suspense fallback={<Loader />}>
                <AppErrorBoundary>
                  <AppRoutes />
                </AppErrorBoundary>
              </Suspense>
              {/* Sky's message bar: one full-width strip under the header
                  (top offset from --app-header-h, see AppLayout) instead of a
                  corner toast stack. Styled in App.css (.sky-message-bar). */}
              <ToastContainer
                className="sky-message-bar"
                position="top-center"
                autoClose={4000}
                hideProgressBar
                newestOnTop
                limit={3}
                icon={false}
                draggable={false}
                transition={Slide}
                closeButton={({ closeToast }) => (
                  <button
                    type="button"
                    className="sky-message-bar__close"
                    onClick={closeToast}
                    aria-label="Close"
                  >
                    <X size={14} strokeWidth={2.5} aria-hidden="true" />
                  </button>
                )}
              />
            </ForgotPasswordModalProvider>
          </ResendEmailModalProvider>
        </SignUpModalProvider>
      </Provider>
    </div>
  );
}

export default App;
